import React from 'react';
import classNames from 'classnames';
import { type MediaPlatformImage } from '@wix/communities-blog-client-common';
import { type CurrentUser } from '../../store/auth/types';
import FluidAvatarImage from '../fluid-avatar-image';
import styles from './header-avatar-image.scss';

const IMAGE_SIZE = parseInt(styles.IMAGE_SIZE, 10) * 2;

type Props = {
  user: CurrentUser | null;
};

const HeaderAvatarImage = ({ user }: Props) => {
  // NOTE: `image` is not a field on Member, so this has always resolved to
  // undefined and rendered the placeholder. Preserved as-is; switching to the
  // profile photo (as UserAvatarImage does) would be a behaviour change.
  const image = (user as { image?: MediaPlatformImage } | null)?.image;

  return (
    <div className={classNames(styles.container, 'header-avatar-image')}>
      <div className={styles.image}>
        <FluidAvatarImage image={image} size={IMAGE_SIZE} ariaLabel="" />
      </div>
    </div>
  );
};

export default HeaderAvatarImage;
